<div class="iwg-country-guide-item-detail">
    <p style="font-size: 14px; color: rgba(0,0,0,0.87); margin-bottom: 10px; line-height: 17px;margin-top:8px;">
        The following information is intended to help inform you of employment policies and holidays relevant to
        managing
        a global workforce. The information provided may not apply to your particular facts or circumstances; therefore,
        you should seek payroll or legal counsel prior to relying on any information that may be contained herein. This
        information and material is for informational purposes only and is not intended to and does not constitute
        payroll or legal advice. Finally, the information provided may not reflect the most recent developments in the
        law, or changes for holidays, and may not be applicable in your particular jurisdiction.
    </p>
</div>



<mat-tab-group animationDuration="0ms">
    <mat-tab class="invisible-tabs" *ngFor="let category of countryGuide?.CountryGuideCategoryViews"
             label="{{category.CategoryName}}" (selectedTabChange)="onTabChanged($event);">
       
            <div style="text-align:right;height:40px;" *ngIf="category.CategoryId == 2">
                <button mat-icon-button (click)="downloadPDF(2, 'Holidays')" class="inputassignicon">
                    <mat-icon style="color: rgba(0,0,0,0.54);">file_download</mat-icon>
                </button>
            </div>
            <div class="culture-container" *ngIf="category.CategoryId == 4">
                <span class="font-content ml-auto">Culture Content Provided by:</span>
                <a href="https://www.globesmart.com/" target="_blank" style="margin-top: 4px;">
                    <img style="height:22px" src="Images/GlobeSmartLogo.png" />
                </a>
                <div class="ml-auto">
                    <button mat-icon-button (click)="downloadPDF(4, 'Culture')" class="inputassignicon"> 
                        <mat-icon style="color: #737373;">file_download</mat-icon>
                    </button>
                </div>
            </div>
            <div style="text-align:right;height:40px;" *ngIf="category.CategoryId == 5">
                <button mat-icon-button (click)="downloadPDF(5, 'Highlights')" class="inputassignicon">
                    <mat-icon style="color: #737373;">file_download</mat-icon>
                </button>
            </div>
            <div class="size">
                <mat-accordion multi *ngIf="category.CategoryId != 5">
                    <mat-expansion-panel *ngFor="let guideItem of category.CountryGuideItems; let pindex = index" [ngClass]="{'cg-no-bottomborder':(pindex==category.CountryGuideItems.length-1)}" >
                        <mat-expansion-panel-header>
                            <mat-panel-title class="iwg-country-guide-item-title">
                                    <div class="tab-height">{{guideItem.ItemName}}
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="iwg-country-guide-item-summary" [innerHTML]="guideItem.ItemSummary"></div>
                        <div class="iwg-country-guide-item-detail"
                                [innerHTML]="guideItem.ItemDetail"></div>
                        
                    </mat-expansion-panel>
                </mat-accordion>
                <div class="iwg-country-guide-column" *ngIf="category.CategoryId == 5">
                    <div class="iwg-country-guide-item" *ngFor="let guideItem of category.CountryGuideItems ; last as islast" >
                        <div class="iwg-country-guide-item-title"><div class="tab-height">{{guideItem.ItemName}}</div></div>
                        <div class="iwg-country-guide-item-summary" [innerHTML]="guideItem.ItemSummary" style="font-size:14px;"></div>
                        <div class="iwg-country-guide-item-detail" [innerHTML]="guideItem.ItemDetail"></div>
                        <mat-divider *ngIf="!islast"></mat-divider>
                    </div>
                </div> 
            </div>
      
    </mat-tab>
</mat-tab-group>
